import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SERVICE_ROLE_KEY = process.env.REACT_APP_SUPABASE_SERVICE_ROLE_KEY;

/**
 * Supabase client using service role key to bypass RLS.
 * Used exclusively for reading the `lilacvalley` schema (website orders).
 * READ-ONLY — never write to this schema from the CRM.
 */
export const lilacvalleyClient = createClient(SUPABASE_URL, SERVICE_ROLE_KEY, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
    detectSessionInUrl: false,
  },
  db: {
    schema: 'lilacvalley',
  },
});
